var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M23.481 0H8.53333C3.08622 0 0 3.08622 0 8.53333V23.4667C0 28.9138 3.08622 32 8.53333 32H23.481C28.928 32 32 28.9138 32 23.4667V8.53333C32 3.08622 28.928 0 23.481 0Z",
    fill: "#CE2600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.5508 19.0898H17.02C16.7731 19.0898 16.5723 19.2939 16.5723 19.5447C16.5723 19.796 16.7731 19.9995 17.02 19.9995H19.5508C19.7977 19.9995 19.9985 19.796 19.9985 19.5447C19.9985 19.2939 19.7977 19.0898 19.5508 19.0898Z",
    fill: "#CE2600"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.2484 13.7347L17.6466 15.6725C17.7044 15.7189 17.7144 15.8039 17.6692 15.8632L14.8261 19.5677C14.6474 19.7966 14.384 19.9261 14.1018 19.9309L12.5498 19.95C12.467 19.951 12.3946 19.8936 12.3757 19.8114L12.023 18.2778C11.9619 17.9959 12.023 17.7045 12.2017 17.4799L15.0589 13.7577C15.105 13.6979 15.1901 13.6874 15.2484 13.7347Z",
    fill: "#CE2600"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18.7199 14.518L18.2576 15.0951C18.211 15.1539 18.1273 15.1634 18.0695 15.1166C17.5074 14.6618 16.0682 13.4946 15.6689 13.1712C15.6106 13.1234 15.6026 13.0383 15.6497 12.9791L16.0955 12.4254C16.5 11.9046 17.2055 11.8568 17.7746 12.3107L18.4283 12.8315C18.6964 13.0417 18.8751 13.3188 18.9363 13.6102C19.0068 13.9308 18.9316 14.2456 18.7199 14.518Z",
    fill: "#CE2600"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditcon);
export default __webpack_public_path__ + "static/media/editcon.5b312915350798486e668e33f4e87b83.svg";
export { ForwardRef as ReactComponent };